import { Grid, Tooltip, Typography } from "@mui/material";
import { CoreContext } from "context/CoreContext";
import moment from "moment";
import { useContext } from "react";
import { theme } from "ui/theme-color";
import { parseStrapiImage } from "utils";
import { getFirstAndLastName } from "utils/formatString";
import {
  AssetsContent,
  AssetsContentItemAction,
  AssetsContentItemActionIcon,
  AssetsContentItemActionIconDownload,
  AssetsContentItemText,
  AssetsContentItemViewIcon,
  UploadLabel,
} from "./styled";
import CardApproved from "../CardApproved";
export default function CardAssets({
  campaign,
  title,
  removable,
  showableAssets,
  reload,
  removeAsset: removeAssetUp,
  showModal = false,
  toReview = false,
  toCampaignCreation = false,
}) {
  const { assets, removeAsset, reloading, setModal, user } =
    useContext(CoreContext);

  function getCloudinaryGif(
    videoUrl,
    options = { start: 2, duration: 4, width: 300 }
  ) {
    if (!videoUrl) return null;

    try {
      const url = new URL(videoUrl);
      const { start, duration, width } = options;

      const pathParts = url.pathname.split("/");
      const fileName = pathParts.pop();
      const publicId = fileName.replace(/\.(mp4|mov|webm|avi|mkv)$/i, "");

      const transformation = `f_gif,so_${start},du_${duration},w_${width}`;
      const uploadIndex = pathParts.findIndex((p) => p === "upload");
      pathParts.splice(uploadIndex + 1, 0, transformation);
      pathParts.push(`${publicId}.gif`);

      return `${url.origin}${pathParts.join("/")}`;
    } catch (err) {
      console.error("Erro ao gerar GIF Cloudinary:", err);
      return null;
    }
  }

  return !(showableAssets || assets)?.length ? null : (
    <>
      {!title ? null : <UploadLabel>{title}</UploadLabel>}

      <AssetsContent>
        {reloading
          ? null
          : (showableAssets || assets)?.map((item, key) => {
              const isDocument = ["pdf", "docx", "xlsx", "csv"].includes(
                item.file?.ext
              );
              const isVideo = ["mp4", "mov", "avi", "webm", "mkv"].includes(
                item.file?.ext
              );
              const imageUrl = isVideo
                ? getCloudinaryGif(item.file?.url)
                : item.file?.previewUrl
                ? item.file.previewUrl
                : item.file?.url;

              return (
                <Grid
                  container
                  key={key}
                  sx={{
                    alignItems: "center",
                    textAlign: "left",
                    padding: "16px 4px 16px 16px",
                    borderBottom: `1px solid ${theme.palette.colors.borderline}`,
                  }}
                >
                  <Grid
                    item
                    size={{ xs: 6, md: 3 }}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <img
                      src={isDocument ? "/icons/document.svg" : imageUrl}
                      width="38px"
                      height="38px"
                      style={{ borderRadius: "8px" }}
                    />
                    <Tooltip title={item?.file?.name}>
                      <AssetsContentItemText>
                        {toCampaignCreation ? item.name : item?.file?.name}
                      </AssetsContentItemText>
                    </Tooltip>
                  </Grid>

                  <Grid item size={{ xs: 0, md: 4 }}>
                    {item.uploadAt != null && (
                      <Tooltip
                        title={item?.uploadBy?.data?.attributes?.name || " "}
                      >
                        <Typography
                          display={{ xs: "none", md: "block" }}
                          style={{
                            margin: 0,
                            fontSize: "12px",
                            marginLeft: "5px",
                          }}
                        >
                          Enviado em:{" "}
                          {moment(item.uploadAt).format("DD/MM/YYYY")} às{" "}
                          {moment(item.uploadAt).format("HH:mm")}, por{" "}
                          {getFirstAndLastName(
                            item?.uploadBy?.data?.attributes?.name
                          ) || " "}
                        </Typography>
                      </Tooltip>
                    )}
                  </Grid>

                  <Grid item size={{ xs: 6, md: 5 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        fontSize: "12px",
                      }}
                    >
                      {toReview ? (
                        item?.approved === undefined ||
                        item?.approved === null ? (
                          <div
                            style={{
                              fontWeight: 500,
                              color: "#5339E3",
                              cursor: "pointer",
                              marginRight: "12px",
                            }}
                            onClick={() =>
                              setModal({
                                type: "review",
                                item: {
                                  ...item,
                                  campaignId: campaign.id,
                                  ratedBy: user.id,
                                  ratedAt: new Date(),
                                },
                                reload,
                              })
                            }
                          >
                            Avaliar entregável
                          </div>
                        ) : (
                          <CardApproved approved={item?.approved} />
                        )
                      ) : null}

                      {item.approved !== null && item.approved !== undefined && (
                        <Tooltip
                          title={item?.ratedBy?.data?.attributes?.name || " "}
                        >
                          <Typography
                            display={{ xs: "none", md: "block" }}
                            style={{
                              margin: 0,
                              fontSize: "12px",
                              marginLeft: "20px",
                            }}
                          >
                            Por{" "}
                            {getFirstAndLastName(
                              item?.ratedBy?.data?.attributes?.name
                            ) || " "}{" "}
                            {moment(item.approvedAt).format("DD/MM/YYYY")} às{" "}
                            {moment(item.approvedAt).format("HH:mm")}
                          </Typography>
                        </Tooltip>
                      )}

                      <AssetsContentItemAction
                        onClick={() =>
                          !item?.file?.url
                            ? null
                            : window.open(
                                parseStrapiImage(item?.file?.url),
                                "campaing-asset"
                              )
                        }
                      >
                        <AssetsContentItemActionIconDownload />
                      </AssetsContentItemAction>

                      <AssetsContentItemAction
                        onClick={() => {
                          setModal({
                            type: "chat",
                            item: {
                              ...item,
                              campaignId: campaign.id,
                            },
                            reload,
                          });
                        }}
                      >
                        <AssetsContentItemViewIcon />
                      </AssetsContentItemAction>

                      {!removable && !removeAssetUp ? null : (
                        <AssetsContentItemAction
                          onClick={() => {
                            setModal({
                              type: "delete-delivery",
                              item: {
                                ...item,
                                campaignId: campaign.id,
                              },
                              reload,
                              removeAsset: removeAssetUp,
                            });
                          }}
                        >
                          <AssetsContentItemActionIcon />
                        </AssetsContentItemAction>
                      )}
                    </div>
                  </Grid>
                </Grid>
              );
            })}
      </AssetsContent>
    </>
  );
}
